<form #formPaymentForm="ngForm">
	<div class="border p-3 mb-3 p-fluid">
		<div class="p-grid">
			<div class="p-col-12 mt-4">
				<span class="p-float-label">
					<input
						type="text"
						autocomplete="cc-number"
						ccNumber
						required
						pInputText
						name="cardNumber"
						[(ngModel)]="paymentData.cardNumber"
						class="w-100"
					/>
					<label>Credit Card Number</label>
				</span>
			</div>
		</div>
		<div class="p-grid">
			<div class="p-col-12 p-md-6 mt-4">
				<span class="p-float-label">
					<p-dropdown
						autocomplete="cc-exp-month"
						required
						name="cardExpirationMonth"
						[(ngModel)]="paymentData.expirationMonth"
						[options]="app.references.months"
						[autoDisplayFirst]="false"
					>
					</p-dropdown>
					<label>Exp. Month</label>
				</span>
			</div>
			<div class="p-col-12 p-md-6 mt-4">
				<span class="p-float-label">
					<p-dropdown
						autocomplete="cc-exp-year"
						required
						name="cardExpirationYear"
						[(ngModel)]="paymentData.expirationYear"
						[options]="app.references.years"
						[autoDisplayFirst]="false"
					>
					</p-dropdown>
					<label>Exp. Year</label>
				</span>
			</div>
		</div>
		<div class="p-grid">
			<div class="p-col-12 p-md-6 mt-4">
				<span class="p-float-label">
					<input
						type="tel"
						autocomplete="cc-csc"
						required
						pInputText
						name="cardCvv"
						[(ngModel)]="paymentData.cvvCode"
						minlength="3"
						maxlength="4"
						class="w-100"
					/>
					<label>Security Code</label>
				</span>
			</div>
			<div class="p-col-12 p-md-6 mt-4">
				<span class="p-float-label">
					<input pInputText type="text" autocomplete="postal-code" required name="postalCode" [(ngModel)]="paymentData.zipCode" class="w-100" />
					<label>Postal Code</label>
				</span>
			</div>
		</div>
		<div class="d-flex w-100">
			<span class="mx-auto">
				<p-button pRipple styleClass="p-button-raised p-button-success m-2 mx-auto" (click)="submitPayment()">
					<ng-template pTemplate="content">
						<div class="d-flex justify-content-center">
							<fa-icon [icon]="['far', 'credit-card-front']" size="lg" class="ms-1 me-2"></fa-icon>
							Submit Payment
						</div>
					</ng-template>
				</p-button>
			</span>
		</div>
	</div>
</form>
